import type React from 'react';
import { useContext } from 'react';

export default function withContext<Props extends {}, ContextKey extends keyof Props, T>(
  Component: React.ComponentType<Props>,
  Context: React.Context<T>,
  contextKey: ContextKey,
): React.ComponentType<Omit<Props, ContextKey>> {
  return function (props: Omit<Props, ContextKey>) {
    const pt = { ...props, [contextKey]: useContext(Context) } as Props;

    return <Component {...pt} />;
  };
}
